import http from '../../utils/http';

// 获取收藏夹列表
export const getFolderList = (searchKey) => {
  const query = searchKey ? `?searchKey=${encodeURIComponent(searchKey)}` : ''
  return http.get(`/api/FavoriteFolder/GetList${query}`);
};

// 新建收藏夹
export const createFolder = (name, sort) => {
  return http.post('/api/FavoriteFolder/Create', { name, sort });
};

// 获取收藏夹内容列表
export const getFolderFiles = (folderId,orderBy) => {
  return http.get(`/api/FavoriteFile/GetByAll?folderId=${folderId}&orderBy=${orderBy}`);
};

// 取消收藏（支持批量）
export const removeCaseFavorite = (ids) => {
  return http.post('/api/CaseFavorite/Remove', { id: ids });
};

// 删除收藏夹
export const deleteFolderApi = (id) => {
  return http.delete(`/api/FavoriteFolder/Delete?id=${id}`);
};
